module.exports = __webpack_public_path__ + "img/Turkmenistan.d1966e59.png";